<template>
  <div class="overlay" @click.self="$emit('cerrar')">
    <div class="modal">
      <h2>Detalle del Turno</h2>

      <div class="info-grid">
        <div class="info-item">
          <span class="label">{{ esBloqueo ? 'Bloqueo' : 'Paciente' }}</span>
          <span class="value">{{ turno.paciente }}</span>
        </div>
        <div class="info-item">
          <span class="label">Motivo</span>
          <div v-if="!editandoMotivo" class="value-row">
            <span class="value">{{ turno.motivo }}</span>
            <button class="btn-icon" @click="iniciarEdicion">✏️</button>
          </div>
          <div v-else class="edit-row">
            <textarea v-model="motivoTemp" id="turno-motivo" name="turno-motivo" autocomplete="off" class="input-edit" rows="2"></textarea>
            <button class="btn-icon-ok" @click="guardarMotivo">✅</button>
            <button class="btn-icon-cancel" @click="cancelarEdicion">❌</button>
          </div>
        </div>
        <div class="info-item">
          <span class="label">Horario</span>
          <span class="value">{{ turno.inicio }} - {{ turno.fin }}</span>
        </div>
        <div v-if="!esBloqueo" class="info-item">
          <span class="label">Estado</span>
          <select :value="turno.estado || 'pendiente'" @change="cambiar($event.target.value)" id="turno-estado" name="turno-estado" class="select-estado" :class="turno.estado || 'pendiente'">
            <option value="pendiente">No confirmado</option>
            <option value="confirmado">Confirmado</option>
            <option value="en curso">En curso</option>
            <option value="atendido">Atendido</option>
            <option value="no asiste">No asiste</option>
            <option value="anulado">Anulado</option>
          </select>
        </div>
      </div>

      <div class="acciones-iconos">
        <a v-if="whatsappLink" :href="whatsappLink" target="_blank" class="accion-btn accion-wpp">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.532 5.862L.057 23.927a.5.5 0 0 0 .609.61l6.213-1.48A11.942 11.942 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.917a9.899 9.899 0 0 1-5.022-1.368l-.36-.214-3.733.89.925-3.64-.235-.374A9.872 9.872 0 0 1 2.083 12C2.083 6.533 6.533 2.083 12 2.083S21.917 6.533 21.917 12 17.467 21.917 12 21.917z"/></svg>
          <span>WhatsApp</span>
        </a>
        <button v-if="!esBloqueo" class="accion-btn accion-editar" @click="$emit('editar', turno)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          <span>Editar</span>
        </button>
        <button class="accion-btn accion-eliminar" @click="intentarEliminar">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
          <span>Eliminar</span>
        </button>
      </div>

      <button class="btn-link" @click="$emit('cerrar')">Cerrar</button>
    </div>
  </div>

  <!-- Modal de pago pendiente -->
  <ModalPagoPendiente 
    :mostrar="mostrarModalPago" 
    @cerrar="cerrarModalPago" 
  />
</template>

<script setup>
import { computed, ref } from 'vue';
import ModalPagoPendiente from '@/components/ModalPagoPendiente.vue';
import { usePagoVerificacion } from '@/composables/usePagoVerificacion';
import { useUsuariosStore } from '@/stores/usuarios';
import { useScrollLock } from '@/composables/useScrollLock';

// El modal solo existe mientras está abierto (v-if en la agenda), así que bloqueamos siempre.
useScrollLock(() => true);

const usuariosStore = useUsuariosStore();

const props = defineProps({
  turno: { type: Object, required: true }
});

const esBloqueo = computed(() => props.turno.tipo === 'bloqueo');

const emit = defineEmits(['cerrar', 'cambiarEstado', 'eliminar', 'guardar', 'editar']);

const { mostrarModalPago, verificarPermisoPago, cerrarModalPago } = usePagoVerificacion();
const editandoMotivo = ref(false);
const motivoTemp = ref('');

function iniciarEdicion() {
  if (!verificarPermisoPago()) {
    return;
  }
  motivoTemp.value = props.turno.motivo;
  editandoMotivo.value = true;
}

function cancelarEdicion() {
  editandoMotivo.value = false;
}

function guardarMotivo() {
  emit('guardar', { id: props.turno.id, motivo: motivoTemp.value });
  editandoMotivo.value = false;
}

function intentarEliminar() {
  if (!verificarPermisoPago()) {
    return;
  }
  emit('eliminar', props.turno.id);
}

function cambiar(estado) {
  if (!verificarPermisoPago()) {
    return;
  }
  emit('cambiarEstado', { id: props.turno.id, estado });
}

const whatsappLink = computed(() => {
  if (!props.turno.telefono) return null;
  
  let numero = props.turno.telefono.replace(/\D/g, '');

  // Si el número empieza con '0' (ej: 099...), se lo quitamos
  if (numero.startsWith('0')) {
    numero = numero.slice(1);
  }

  // Si no empieza con el código de país (598), se lo agregamos
  if (!numero.startsWith('598')) {
    numero = '598' + numero;
  }

  // Formatear fecha de YYYY-MM-DD a DD/MM/YYYY para el mensaje
  let fechaStr = props.turno.fecha;
  if (fechaStr && fechaStr.includes('-')) {
    const [anio, mes, dia] = fechaStr.split('-');
    fechaStr = `${dia}/${mes}/${anio}`;
  }

  const direccion = usuariosStore.usuarioActual?.direccionTrabajo;
  const partesDireccion = direccion ? ` Te esperamos en ${direccion}.` : '';
  const mensaje = `Hola ${props.turno.paciente}, Te recuerdo tu cita para el día ${fechaStr} a las ${props.turno.inicio} hs.${partesDireccion}`;
  return `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
});
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  font-family: system-ui, sans-serif;
}

.modal {
  background: white;
  padding: 24px;
  border-radius: 16px;
  width: 90%;
  max-width: 350px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);

  /* Nunca más alto que la pantalla, y si no entra se desliza dentro del modal.
     Sin esto, en iPhone (teclado abierto) los botones de abajo quedaban fuera de la vista.
     dvh tiene en cuenta la barra dinámica de Safari; vh es el respaldo para navegadores viejos. */
  max-height: 90vh;
  max-height: 90dvh;
  overflow-y: auto;
}

h2 {
  margin-top: 0;
  color: #678AB2;
}

.info-grid {
  text-align: left;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.value {
  font-size: 15px;
  color: #111;
  font-weight: 600;
}

.value-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-row {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.input-edit {
  flex: 1;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  font-family: serif;
}

.btn-icon, .btn-icon-ok, .btn-icon-cancel {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 4px;
}

.badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  width: fit-content;
}
.select-estado {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: 1.5px solid #d1d5db;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 32px;
}
.select-estado.pendiente  { background-color: white;    color: #374151; border-color: #d1d5db; }
.select-estado.confirmado { background-color: #d1fae5; color: #065f46; border-color: #6ee7b7; }
.select-estado.atendido   { background-color: #e0e7ff; color: #3730a3; border-color: #a5b4fc; }
.select-estado.anulado    { background-color: #fee2e2; color: #991b1b; border-color: #fca5a5; }
.select-estado.no.asiste  { background-color: #fef3c7; color: #92400e; border-color: #fcd34d; }
.select-estado.en.curso   { background-color: #fff7ed; color: #c2410c; border-color: #fed7aa; }

.acciones-extra {
  margin-bottom: 16px;
  display: flex;
}

.acciones-iconos {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.accion-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 12px;
  transition: background 0.15s;
  min-width: 72px;
}

.accion-wpp  { color: #16a34a; }
.accion-wpp:hover  { background: #f0fdf4; }

.accion-editar { color: #678AB2; }
.accion-editar:hover { background: #f0f4f9; }

.accion-eliminar { color: #dc2626; }
.accion-eliminar:hover { background: #fef2f2; }

.btn-link {
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #9ca3af;
  margin-top: 12px;
  width: 100%;
}

@media (max-width: 480px) {
  .value {
    font-size: 16px;
  }
}
</style>